module.exports = __webpack_public_path__ + "static/media/story-6.bc3094af.png";